<template>
  <main class="wallet-transfer-success-page">
    <header class="transfer-success-navbar">
      <button
        class="transfer-success-back"
        type="button"
        :aria-label="t('home.home')"
        @click="goHome"
      >
        <img :src="backIcon" alt="" />
      </button>
      <h1>{{ t("wallet.transferApplySubmittedTitle") }}</h1>
    </header>

    <section class="transfer-success-content">
      <div class="transfer-success-illustration">
        <img class="transfer-success-glow" :src="glowImage" alt="" />
        <div class="transfer-success-illustration__frame">
          <img :src="heroImage" alt="" />
        </div>
      </div>

      <div class="transfer-success-summary">
        <h2>{{ t("wallet.transferApplySubmitted") }}</h2>
        <span>{{ t("wallet.transferUnderReview") }}</span>
      </div>

      <p class="transfer-success-description">
        {{ t("wallet.transferReviewEta") }}
      </p>

      <section class="transfer-success-notice">
        <img :src="noticeImage" alt="" />
        <div class="transfer-success-notice__copy">
          <strong>{{ t("wallet.transferSubmitNotice") }}</strong>
          <p>{{ t("wallet.transferViewFlowHint") }}</p>
        </div>
      </section>
    </section>

    <button
      class="transfer-success-support"
      type="button"
      @click="goSupport"
    >
      <AppSvgIcon :src="supportIcon" size="20" />
      <span>{{ t("wallet.transferContactSupport") }}</span>
    </button>
  </main>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import backIcon from "@/assets/images/SVG/icon/transfer-submitted-back.svg";
import supportIcon from "@/assets/images/SVG/icon/transfer-submitted-support.svg";
import glowImage from "@/assets/images/SVG/icon/transfer-submitted-glow.svg";
import heroImage from "@/assets/images/transfer/transfer-submitted-hero.png";
import noticeImage from "@/assets/images/transfer/transfer-submitted-tip.png";

const { t } = useI18n();
const router = useRouter();

function goHome() {
  router.replace("/home/index");
}

function goSupport() {
  router.push("/mine/support-chat");
}
</script>

<style scoped lang="scss">
.wallet-transfer-success-page {
  display: flex;
  width: 100%;
  max-width: 430px;
  min-height: var(--app-viewport-height);
  flex-direction: column;
  margin: 0 auto;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  overflow-x: hidden;
  background: #ffffff;
}

.transfer-success-navbar {
  position: relative;
  display: flex;
  height: 46px;
  flex: 0 0 46px;
  align-items: center;
  justify-content: center;

  h1 {
    margin: 0;
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
  }
}

.transfer-success-back {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 44px;
  height: 46px;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0 0 16px;
  border: 0;
  background: transparent;

  img {
    display: block;
    width: 11px;
    height: 17px;
  }
}

.transfer-success-content {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  align-items: center;
  padding: 28px 16px 0;
}

.transfer-success-illustration {
  position: relative;
  width: 100px;
  height: 100px;
  flex: 0 0 100px;
}

.transfer-success-glow {
  position: absolute;
  top: 90px;
  left: -4px;
  display: block;
  width: 108.2px;
  height: 30.2px;
}

.transfer-success-illustration__frame {
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;

  img {
    position: absolute;
    top: -18.29%;
    left: -21.95%;
    display: block;
    width: 145.12%;
    max-width: none;
    height: 145.12%;
    object-fit: cover;
  }
}

.transfer-success-summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;

  h2 {
    margin: 0;
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
  }

  span {
    margin-top: 12px;
    padding: 4px 6px;
    border-radius: 4px;
    background: rgba(116, 66, 232, 0.12);
    color: #7442e8;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }
}

.transfer-success-description {
  max-width: 320px;
  margin: 12px 0 0;
  color: #999999;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
}

.transfer-success-notice {
  display: flex;
  width: 100%;
  min-height: 90px;
  align-items: center;
  gap: 10px;
  margin-top: 24px;
  padding: 14px 16px;
  border-radius: 16px;
  background: #f7f3ff;

  > img {
    display: block;
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    object-fit: cover;
  }
}

.transfer-success-notice__copy {
  min-width: 0;

  strong {
    display: block;
    color: #090a1d;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }

  p {
    margin: 6px 0 0;
    color: #747b88;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
}

.transfer-success-support {
  display: flex;
  width: calc(100% - 32px);
  min-height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin: auto 16px 0;
  padding: 0 12px;
  border: 0;
  border-radius: 30px;
  background: #f7f3ff;
  color: #7442e8;
  font-size: 16px;
  font-weight: 500;

}
</style>
